import { saveAs } from 'file-saver'

export const downloadFile = async (
  url: string,
  filename: string
): Promise<void> => {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Download failed with status ${response.status}`)
  }
  saveAs(await response.blob(), filename)
}
